import { REPORT_SPA_QUERY_PARAMS } from "@core/reports/constants/reportSpaQueryParams";

export const ACTIVITY_ENTRY_QUERY_PARAMS = {
  REPORT_TEMPLATE_ID: REPORT_SPA_QUERY_PARAMS.TEMPLATE_ID,
  REPORT_TAG_ID: REPORT_SPA_QUERY_PARAMS.TAG_ID,
  DEPARTMENT_ID: REPORT_SPA_QUERY_PARAMS.DEPARTMENT_ID,
} as const;

export type ActivityEntrySubmitSearchIds = {
  reportTemplateId?: number;
  reportTagId?: number;
  departmentId?: number;
};

export type ParsedActivityEntrySubmitSearch = {
  reportTemplateId: number;
  reportTagId: number;
  departmentId: number;
};

function isPositiveId(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value) && value > 0;
}

function parsePositiveId(raw: string | null): number {
  if (raw == null || raw === "") {
    return 0;
  }
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return 0;
  }
  return parsed;
}

export function buildActivityEntrySubmitSearch(
  ids: ActivityEntrySubmitSearchIds = {}
): URLSearchParams {
  const params = new URLSearchParams();
  if (isPositiveId(ids.reportTemplateId)) {
    params.set(
      ACTIVITY_ENTRY_QUERY_PARAMS.REPORT_TEMPLATE_ID,
      String(ids.reportTemplateId)
    );
  }
  if (isPositiveId(ids.reportTagId)) {
    params.set(ACTIVITY_ENTRY_QUERY_PARAMS.REPORT_TAG_ID, String(ids.reportTagId));
  }
  if (isPositiveId(ids.departmentId)) {
    params.set(ACTIVITY_ENTRY_QUERY_PARAMS.DEPARTMENT_ID, String(ids.departmentId));
  }
  return params;
}

export function parseActivityEntrySubmitSearch(
  searchParams: URLSearchParams
): ParsedActivityEntrySubmitSearch {
  return {
    reportTemplateId: parsePositiveId(
      searchParams.get(ACTIVITY_ENTRY_QUERY_PARAMS.REPORT_TEMPLATE_ID)
    ),
    reportTagId: parsePositiveId(
      searchParams.get(ACTIVITY_ENTRY_QUERY_PARAMS.REPORT_TAG_ID)
    ),
    departmentId: parsePositiveId(
      searchParams.get(ACTIVITY_ENTRY_QUERY_PARAMS.DEPARTMENT_ID)
    ),
  };
}
